import {useAuth0} from "@auth0/auth0-react";
import {ActionButton} from "../../util/UI/ActionButton";
import {JoinKensu} from "../Home/JoinKensu";

export const CreateUserAccount = () => {

  const {loginWithPopup} = useAuth0();
  
  return <div style={{display: 'flex', flexDirection: "column", alignItems:'center', textAlign: 'start'}}>
    <JoinKensu/>
  </div>
}